<template>
  <div>
    <loading-overlay :active="isLoading" :is-full-page="true" />
    <div class="home">
      <div id="multistepsform">
        <ul id="progressbar">
          <li class="active">Scan Qr Code</li>
          <li>Copy User Information</li>
          <li>Input Tracking Number</li>
        </ul>
      </div>
      <div class="card" style="width: 46rem;" v-if="step == 1">
        <div class="card-header text-start">
          Step 1 - Scan Qr Code
        </div>
        <div class="card-body">
          <input type="text" class="form-control" :class="{'is-invalid': errors && errors.code ? true : false }" v-model="code"  v-on:keyup.enter="scan">
          <span class="float-start text-danger"  v-if="errors && errors.code">{{errors.code[0]}}</span>
        </div>
        <div class="card-footer">
          <button class="btn btn-tracking float-end" @click="scan" >Scan</button>
        </div>
      </div>
      <div style="width: 46rem">
        <div class="card mb-3 pb-0" :key="fk" v-for="fv, fk in data" >
          <div v-if="fk == 'user' ? step == 2 || step == 3 : step == 2" style="padding-bottom: 8px;">
          <div class="card-header text-start">
            {{ucwords(fk)}} Detail
          </div>
          <div class="card-body pb-0">
            <div class="row mb-2">
              <div class="col-2 text-start text-tracking">Title</div>
              <div class="col text-start text-tracking">
                Information
              </div>
            </div>
            <div class="row mb-2" :key="field" v-for="values, field in fv" :class="field == 'item' || field == 'receiver_address' ? '' : 'b-b'">
              <div class="col-2 text-start font-8rem">
                {{ucwords(field)}}
              </div>
              <div class="col text-start">
                <div :key="k" v-for="v,k in values">
                  <div class="d-flex justify-content-between mb-1">
                    <div class="font-8rem fw-bold w-20" v-if="v">
                      {{ucwords(k)}}
                    </div>
                    <div class="text-end w-100 pe-3 ">                  
                      <small class="text-muted " @click.right.prevent @copy.prevent @paste.prevent>
                        {{v}}
                      </small>
                    </div>
                    <div :class="{'w-8': k=='id' ? true : false }">
                      <button v-if="k != 'id'" type="button" :ref="'button'+field+k" class="btn btn-tracking btn-sm mb-1" @click="clipboard(v,field,k)">Copy</button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="card-footer" v-if="fk == 'address'">
            <button class="btn btn-tracking float-start" @click="stepTo(1)">Back</button>
            <button class="btn btn-tracking float-end" @click="stepTo(3,true)">Next</button>
          </div> 
        </div>
        </div>
      </div>
      <div class="card" style="width:46rem" v-if="step == 3">
        <div class="card-header text-start">
          Step 3 - Input Tracking Number
        </div>
        <div class="card-body">
          <div class="mb-2 text-start">
            <label class="form-label">Select Prefer Courier</label>
            <v-select v-model="courier" :class="{'is-invalid': errors && errors.courier ? true : false }" label="text" :options="options"/>
            <span class="float-start text-danger"  v-if="errors && errors.courier">{{errors.courier[0]}}</span>
          </div>
          <br>
          <div class="mb-2 text-start">
            <label class="form-label">Tracking Number</label>
            <input type="text" class="form-control" :class="{'is-invalid': errors && errors.tracking_number ? true : false }" v-model="tracking_number">
            <span class="float-start text-danger"  v-if="errors && errors.tracking_number">{{errors.tracking_number[0]}}</span>
          </div>
        </div>
        <div class="card-footer">
          <button class="btn btn-tracking float-end" @click="submit">Submit</button>
          <button class="btn btn-tracking float-start" @click="stepTo(2)">Back</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
'use strict';

// const Store = window.require('electron-store');
// const store = new Store();
// const electron = window.require("electron")
// console.log(electron)
export default {
  name: 'HomePage',
  components: {
    // Loading
  },
  data(){
    return{
      errors: null,
      code: '',
      tracking_number: '',
      step: 1,
      data: {},
      options: JSON.parse(localStorage.getItem('couriers')),
      courier: [],
      el:null,
      isLoading: false,
      interval: null
    }
  },
  mounted(){
    this.el = document.createElement('input'); 
    this.el.setAttribute('readonly', '');                
    this.el.style.position = 'absolute';                     
    this.el.style.left = '-9999px';                      
    document.body.appendChild(this.el);
    clearInterval(this.interval)  
    this.checkOnline();
  },
  methods: {
    scan(){
      if(!this.code){
        this.errors = {
          code: ['Qr code is required']
        }
        return;
      }
      this.isLoading = true;
      this.courier = []
      this.axios.get(`https://${process.env.VUE_APP_DOMAIN}/api/software/delivery-code/${this.code}`,{
        headers: {
          'Tracking-Software-Api-Key': localStorage.getItem('apiToken')
        }
      }).then(res => {
        // this.options = res.data.couriers;
        if(this.options.length == 1){
          this.courier = this.options[0]
        }

        this.data.user = {
          user: res.data.delivery_code.user,
          item: {
            currency: res.data.delivery_code.currency,
            value: res.data.delivery_code.value,
            content: res.data.delivery_code.content,
          }
        }
        this.data.address = {
            sender_address: res.data.delivery_code.sender_address,
            receiver_address: res.data.delivery_code.receiver_address
        } 

        setTimeout(() => {
          this.isLoading = false;
          this.stepTo(2)
        }, 500);
      }).catch(err => {
        this.isLoading = false;
        this.errors = err.response.data.errors
        if(err.response.status == 401){
          localStorage.removeItem('apiToken');
          clearInterval(this.interval)
          this.$router.push({name: 'login'});
        }else if(err.response.status == 500){
          this.$swal({
            icon: 'error',
            title: 'Oops.. Something Wrong',
            text: 'Please contact Tracking.my IT department',
            confirmButtonColor: '#ff6700'
          })
          this.stepTo(1);
        }
      })
    },
    stepTo(step, loading = false){
      let li = document.querySelectorAll('#progressbar > li');

      li.forEach((v,k) => {
        v.classList.remove('active')
        if(step - 1 >= k){
          v.classList.add('active')
        }
      })
      if(loading){      
        this.isLoading = true
        setTimeout(() => {
          this.isLoading = false;
          this.step = step
        }, 500);
      }else{
        this.step = step
      }
    },
    ucwords(string) {
      let pattern = {
        sender_address: 'Sender Address',
        receiver_address: 'Receiver Address',
        full_address: 'Full Address'
      }

      if(pattern[string]){
        string = pattern[string]
      }

      return string.charAt(0).toUpperCase() + string.slice(1);
    },
    clipboard(string,field,key = '') {
        let button;
        button = this.$refs['button'+field+key][0];
        this.toggleCopyButton(button);
        this.el.value = string;                                 
                 
        const selected =  document.getSelection().rangeCount > 0  ? document.getSelection().getRangeAt(0) : false;                                    
        this.el.select();                                    
        document.execCommand('copy');                   
        // document.body.removeChild(el);                  
        if (selected) {                                 
          document.getSelection().removeAllRanges();    
          document.getSelection().addRange(selected);   
        }
    },
    toggleCopyButton(button){
      button.innerText = 'Copied'
      button.classList.add('btn-tracking-active')
      setTimeout(() => {
        button.innerText = 'Copy'
        button.classList.remove('btn-tracking-active')
      },2000)
    },
    submit(){
      this.isLoading = true;
      this.axios.post(`https://${process.env.VUE_APP_DOMAIN}/api/software/delivery-code/${this.code}`,{
        code: this.code,
        tracking_number: this.tracking_number,
        courier: this.courier,
      },{
        headers: {
          'Tracking-Software-Api-Key': localStorage.getItem('apiToken')
        }
      }).then(() => {
        this.$swal({
          icon: 'success',
          title: 'System Reminder!',
          text: 'Submit Successfully',
          confirmButtonColor: '#ff6700'
        })
        this.code = null
        this.tracking_number = null
        this.courier = []
        this.data = {}
        this.isLoading = false;
        this.stepTo(1)
      }).catch(err => {

        this.isLoading = false;
        if(err.response.status == 401){
          localStorage.removeItem('apiToken');
          clearInterval(this.interval)
          this.$router.push({name: 'login'});
        }else if(err.response.status == 422){
          this.errors = err.response.data.errors
        }else if(err.response.status == 500){
          this.$swal({
            icon: 'error',
            title: 'Oops.. Something Wrong',
            text: 'Please contact Tracking.my IT department',
            confirmButtonColor: '#ff6700'
          })
          this.stepTo(1);
        }
      })
    },
    checkOnline(){
      this.axios.get(`https://${process.env.VUE_APP_DOMAIN}/api/software/device`,{
        headers: {
          'Tracking-Software-Api-Key': localStorage.getItem('apiToken')
        }
      }).then(() => {

      }).catch(err => {
        if(err.response && err.response.status == 401){
          localStorage.removeItem('apiToken');
          clearInterval(this.interval)      
          this.$router.push({name: 'login'});
        }          
      })

      this.interval = setInterval(() => { 
        this.axios.get(`https://${process.env.VUE_APP_DOMAIN}/api/software/device/online`,{
          headers: {
            'Tracking-Software-Api-Key': localStorage.getItem('apiToken')
          }
        }).then(() => {

        }).catch(err => {
          if(err.response.status == 401){
            localStorage.removeItem('apiToken');
            clearInterval(this.interval)      
            this.$router.push({name: 'login'});
          }
        })
      }, 60000 * 5);
    },
  },
  watch: {
    code(val) {
      if(val && this.errors && this.errors.code) this.errors.code = null
    },
    tracking_number(val){
      if(val && this.errors && this.errors.tracking_number) this.errors.tracking_number = null
    },
    courier(val){
      if(val && this.errors && this.errors.courier) this.errors.courier = null
    }
  }
}
</script>

<style scoped>

span, h5, p{
  font-family: 'proxima-nova', sans-serif!important;
  font-weight: 500!important;
  letter-spacing: .08em!important;
  line-height: 1.6!important;
  font-size: .8rem;
}

.home{
  flex-direction: column;
  flex-wrap: wrap;
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 50px;
}

.container {
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
    -webkit-user-select: none;  
    -moz-user-select: none;  
    -ms-user-select: none;  
    -o-user-select: none;  
    user-select: none;
}

.card-footer {
    padding: 0.5rem 1rem!important;
    background-color: unset!important; 
    /*border-top: ; */
}

.w-20{
  width: 20%!Important;
}

.lh-20{
  line-height: 20px!important;
}

.box {
  height: 100px;
  width: 200px;
  background: #fff;
  padding: 50px;
  border-radius: 10px;
  position: relative;
  text-align: center;
}

.text-tracking{
  color: #ff6700;
}

.btn-tracking{
  font-size: 55%!important;
  border-color: #ff6700;
  color: #ff6700;
}

.btn-tracking:hover{
  background-color: #ff6700;
  color: white;
}

.btn-tracking-active{
  background-color: #ff6700;
  color: white; 
}

.font-8rem{
  font-size: .8rem!important;

}

.b-b{
  border-bottom: 1px solid #e5e5e5;
}

.w-8{
    width: 8%;
}

.card-body {
  /*padding: 0.5rem 1.2rem 0rem 1.2rem!important;*/
}

#multistepsform {
  width: 46rem;
  margin: 20px auto 0 auto;
  text-align: center;
  position: relative;
}
#multistepsform fieldset {
  background: white;
  border: 0 none;
  border-radius: 3px;
  box-shadow: 0 0 15px 1px rgba(0, 0, 0, 0.4);
  padding: 20px 30px;
  box-sizing: border-box;
  width: 80%;
  margin: 0 10%;
  position: relative;
}
#multistepsform fieldset:not(:first-of-type) {
  display: none;
}
#multistepsform input,
#multistepsform textarea {
  padding: 15px;
  border: 1px solid #ccc;
  border-radius: 3px;
  margin-bottom: 10px;
  width: 100%;
  box-sizing: border-box;
  font-family: montserrat;
  color: #2c3e50;
  font-size: 13px;
}
#multistepsform input:focus,
#multistepsform textarea:focus {
  border-color: #679b9b;
  outline: none;
  color: #637373;
}
#multistepsform .action-button {
  width: 100px;
  background: #ff6700;
  font-weight: bold;
  color: #fff;
  transition: 150ms;
  border: 0 none;
  border-radius: 1px;
  cursor: pointer;
  padding: 10px 5px;
  margin: 10px 5px;
}
#multistepsform .action-button:hover,
#multistepsform .action-button:focus {
  box-shadow: 0 0 0 2px #f08a5d, 0 0 0 3px #ff976;
  color: #fff;
}
#multistepsform .fs-title {
  font-size: 15px;
  text-transform: uppercase;
  color: #2c3e50;
  margin-bottom: 10px;
}
#multistepsform .fs-subtitle {
  font-weight: normal;
  font-size: 13px;
  color: #666;
  margin-bottom: 20px;
}
#multistepsform #progressbar {
  margin-bottom: 30px;
  overflow: hidden;
  counter-reset: step;
    padding-left: 0;
}
#multistepsform #progressbar li {
  list-style-type: none;
  color: #679b9b;
  text-transform: uppercase;
  font-size: 11px;
  width: 33.33%;
  float: left;
  position: relative;
}
#multistepsform #progressbar li:before {
  content: counter(step);
  counter-increment: step;
  width: 20px;
  line-height: 20px;
  display: block;
  font-size: 9px;
  color: #fff;
  background: #679b9b;
  border-radius: 4px;
  margin: 0 auto 5px auto;
}
#multistepsform #progressbar li:after {
  content: "";
  width: 100%;
  height: 2px;
  background: #679b9b;
  position: absolute;
  left: -50%;
  top: 9px;
  z-index: -1;
}
#multistepsform #progressbar li:first-child:after {
  content: none;
}
#multistepsform #progressbar li.active {
  color: #ff6700;
}
#multistepsform #progressbar li.active:before, #multistepsform #progressbar li.active:after {
  background: #ff6700;
  color: white;
}

.border-danger{
  border-color: red;
}

</style>